import React, { useState } from 'react';
import './SubjectWiseFilter.css';
import { Filter, Search } from 'lucide-react';

const SubjectWiseFilter = () => {
  const [filters, setFilters] = useState({
    subject: '',
    state: '',
    year: '',
  });

  const handleChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const handleSearch = () => {
    // TODO: Add real filtering logic
    console.log('Filter applied:', filters);
  };

  return (
    <section className="subject-wise-section">
      <div className="subject-wise-container">
        <h2 className="subject-wise-title">
          <Filter size={24} /> Filter Toppers by Subject, State & Year
        </h2>

        <div className="subject-wise-filters">
          <select name="subject" onChange={handleChange} className="subject-wise-select">
            <option value="">Optional Subject</option>
            <option value="History">History</option>
            <option value="Geography">Geography</option>
            <option value="Sociology">Sociology</option>
            <option value="PSIR">PSIR</option>
          </select>

          <select name="state" onChange={handleChange} className="subject-wise-select">
            <option value="">Select State</option>
            <option value="Tamil Nadu">Tamil Nadu</option>
            <option value="Maharashtra">Maharashtra</option>
            <option value="Karnataka">Karnataka</option>
            <option value="Delhi">Delhi</option>
          </select>

          <select name="year" onChange={handleChange} className="subject-wise-select">
            <option value="">Select Year</option>
            <option value="2025">2025</option>
            <option value="2024">2024</option>
            <option value="2023">2023</option>
          </select>

          <button onClick={handleSearch} className="subject-wise-search-btn">
            <Search size={18} /> Search
          </button>
        </div>
      </div>
    </section>
  );
};

export default SubjectWiseFilter;
